import { browser } from "$app/environment";

let gsap, ScrollTrigger;

async function loadGSAP() {
  if (!browser || gsap || ScrollTrigger) return; // Prevent multiple loads

  const gsapModule = await import("gsap");
  gsap = gsapModule.gsap;

  const scrollTriggerModule = await import("gsap/ScrollTrigger");
  ScrollTrigger = scrollTriggerModule.ScrollTrigger;

  gsap.registerPlugin(ScrollTrigger);
}

export async function animateBatch(scroller = "#scroller") {
  if (!browser) return;

  await loadGSAP(); // Ensure GSAP is ready

  if (!gsap || !ScrollTrigger) {
    console.warn("⚠️ GSAP or ScrollTrigger failed to load.");
    return;
  }

  console.log("✅ GSAP and ScrollTrigger loaded successfully.");

  const scrollContainer = document.querySelector(scroller);
  if (!scrollContainer) {
    console.warn(`⚠️ Scroller "${scroller}" not found.`);
    return;
  }

  // 🚀 Make GSAP track the correct scrolling container
  ScrollTrigger.scrollerProxy(scroller, {
    scrollTop(value) {
      return value !== undefined ? (scrollContainer.scrollTop = value) : scrollContainer.scrollTop;
    },
    getBoundingClientRect() {
      return {
        top: 0,
        left: 0,
        width: scrollContainer.clientWidth,
        height: scrollContainer.clientHeight,
      };
    },
    pinType: scrollContainer.style.transform ? "transform" : "fixed",
  });

  // Sync GSAP with native scroll events
  scrollContainer.addEventListener("scroll", () => {
    ScrollTrigger.update();
  });

  // 🚀 Animate all `.animate-up` elements inside `#scroller`
  const animationUp = document.querySelectorAll(".animate-up");
  if (!animationUp || animationUp.length === 0) return;

  gsap.set(animationUp, { y: 30, opacity: 0 });

  ScrollTrigger.batch(animationUp, {
    onEnter: (batch) => {
      gsap.to(batch, {
        duration: 0.5,
        autoAlpha: 1,
        y: 0,
        stagger: 0.4,
        delay: 0,
        ease: "Power3.easeInOut",
      });
    },
    start: "top 90%",
    end: "bottom 20%",
    scroller: scroller,
  });
  

  // 🚀 Animate all `.animate-right` elements inside `#scroller`
  const animationRight = document.querySelectorAll(".animate-right");
  if (!animationRight || animationRight.length === 0) return;

  gsap.set(animationRight, { y: 0, x: 30, opacity: 0 });

  ScrollTrigger.batch(animationRight, {
    onEnter: (batch) => {
      gsap.to(batch, {
        duration: 0.5,
        autoAlpha: 1,
        x: 0,
        stagger: 0.4,
        delay: 0.3,
        ease: "Power2.easeInOut",
      });
    },
    start: "top 80%",
    end: "bottom 20%",
    scroller: scroller,
  });

   
  
   // 🚀 Animate all `.animate-left` elements inside `#scroller`
   const animationLeft = document.querySelectorAll(".animate-left");
   if (!animationLeft || animationLeft.length === 0) return;
 
   gsap.set(animationLeft, { y: 0, x: -30, opacity: 0 });
 
   ScrollTrigger.batch(animationLeft, {
    onEnter: (batch) => {
      gsap.to(batch, {
        duration: 0.5,
        autoAlpha: 1,
        x: 0,
        stagger: 0.4,
        delay: 0.3,
        ease: "Power2.easeInOut",
      });
    },
    start: "top 80%",
    end: "bottom 20%",
    scroller: scroller,
  });

   // 🚀 Animate all `.animate-shake` elements inside `#scroller`
   const animationShake = document.querySelectorAll(".animate-shake");
   if (!animationShake || animationShake.length === 0) return;
 
   gsap.set(animationShake, { y: 0, x: -40, opacity: 0 });
 
   ScrollTrigger.batch(animationShake, {
    onEnter: (batch) => {
      gsap.to(batch, {
        duration: 1.2,
        autoAlpha: 1,
        x: 0,
        stagger: 0.4,
        delay: 0.3,
        ease: "elastic.out(1,0.3)",
      });
    },
    start: "top 80%",
    end: "bottom 20%",
    scroller: scroller,
  });
 
 

    

  // 🚀 Ensure ScrollTrigger refreshes after setup
  setTimeout(() => {
    console.log("🔄 Refreshing ScrollTrigger...");
    ScrollTrigger.refresh();
  }, 500);
}